import React, { Component } from 'react'
import PropTypes from 'prop-types'

import './style.scss'

export default class InactiveIndicatorCell extends Component {
    static propTypes = {
        inactive: PropTypes.bool,
    }

    static defaultProps = {
        inactive: false,
    }

    render() {
        const { inactive } = this.props

        if (!inactive) return null

        return <div className={'inactive-indicator-cell'} />
    }
}
